import { connect } from 'react-redux';
import { setHeaderTitle } from '../../../actions/layout';
import ManagerListItem from './ManagerList';
import { push } from 'react-router-redux/lib/actions';
import CRUDActions from '../../../actions/manager';
import { getManagersByClubId } from '../../../selectors/club-settings'

export default connect(
  state => ({
    headerTitle: 'Managers',
    loading: state.manager.loading,
    loadingMore: state.manager.loadingMore,
    hasMore: state.manager.hasMore,
    list: state.manager.list,
    items: getManagersByClubId(state.manager.items, state)
  }),
  (dispatch) => ({
    updateHeaderTitle: (title) => dispatch(setHeaderTitle(title)),
    fetch: () => dispatch(CRUDActions.fetchList()),
    fetchModel: (id) => dispatch(CRUDActions.fetch(id)),
    fetchMore: () => dispatch(CRUDActions.fetchListMore()),
    edit: (id) => dispatch(push(`/managers/edit/${id}`)),
    add: () => dispatch(push('/managers/new'))
  })
)(ManagerListItem);



// WEBPACK FOOTER //
// ./src/components/Managers/ManagersList/index.js